import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { locationsLogListKey } from '@pages/ManageLocations/services/useLocationsLogListInfiniteQuery';

import { apiClient } from '@services/apiClient';
import { locationsGetOneKey } from '@services/useLocationsGetOneQuery';

import { assetTreeKey } from './useAssetTreeQuery';

const locationsSaveFn = (data) => apiClient.post(`${APP_API_URL}locations/save`, data);

export const useLocationsSaveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: locationsSaveFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: assetTreeKey() });
      queryClient.invalidateQueries({ queryKey: [locationsGetOneKey()[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [locationsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
